/*global google*/
import * as React from "react";
import { render } from "react-dom";
import { Button } from 'react-bootstrap';
import { Parser } from 'json2csv';
import axios from 'axios';
import _ from 'lodash';
import moment from "moment";
import * as turf from '@turf/turf';
import { CSVLink, CSVDownload } from "react-csv";
import polygonCenter from 'geojson-polygon-center';
// var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
import mapboxgl from 'mapbox-gl';
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//import * as L from 'leaflet';
import L from 'leaflet';
import 'leaflet.markercluster';
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import metaData from "../metaData";
import map_style from "./map_style.json";
import ZipprData from "./zipprData";
import loader from "../images/loader.gif"
import mapLoader from "../images/mapLoading.gif";
import {
  Grid,
  TextField
} from "@material-ui/core";
let useState = React.useState;
let self;
let th;
let addDates = metaData[0].addDates;
let analyticsResponse;
// const L = window['L'];
var map = '';
let map_upSideShowing_layers = [];
// let previousLayer = 'third-layer';
let layer1_count = 0;
let layer2_count = 0;
let layer3_count = 0;
let layer4_count = 0;
let layer5_count = 0;
let layer3displayDataArr = [];
let initialCenter = [];
let addLayersFunction;
let geoJsonObjFeaturesLayer3 = [];
var popup;
let ddn_search_count = 1;
var firstLayerNotPresent = 0;
var addControllCount = 0;

var nav = new mapboxgl.NavigationControl();

function removeNullParams(params){
console.log(params.toDate,"paramsnulll");
for (let propName in params) {
  if (params[propName] === null || params[propName] === undefined) {
    delete params[propName];
  }
}

}

function filteredArray(layer2_displayDataArr) {
  let modefiedArray2 = [];
  let modefiedArray = [];
  let buildingsArray = [];
  let dwellingsArray = [];
  layer2_displayDataArr.map(ele => {
    if (ele.zp_type == 7) {
      buildingsArray.push(ele);
    } else if (ele.zp_type == 8) {

      dwellingsArray.push(ele);
    }
  })
	console.log(buildingsArray,"buildingsArray");
	console.log(dwellingsArray,"dwellingsArray");
  // let modefiedArray2=[];
  if (!buildingsArray.length) {
    let dwellArr = [];
    dwellingsArray.map(dwell => {
      dwell.dwellings = dwell.ddn_count ? dwell.ddn_count : 0;
      dwell.ddn_count = 0;
      dwellArr.push(dwell)
    })
    modefiedArray2 = dwellArr;
  }

  if (!dwellingsArray.length) {

    modefiedArray2 = buildingsArray;
  } else {
    buildingsArray.map(building => {
      let haveBuilding = false;
      dwellingsArray.map(dwelling => {
        if (building.display_name == dwelling.display_name) {
          haveBuilding = true;
          building.dwellings = dwelling.ddn_count ? dwelling.ddn_count : 0;
          modefiedArray2.push(building)
	  dwelling.matched = true;
        }
        if (!haveBuilding) {
          building.dwellings = 0;
          modefiedArray2.push(building)
        }

      })
    })
	  let unmatchedDwellings = dwellingsArray.filter(dwelling => !dwelling.hasOwnProperty("matched"));
	  for(let i = 0; i < unmatchedDwellings.length; i++){
             	unmatchedDwellings[i].dwellings = unmatchedDwellings[i].ddn_count;
		unmatchedDwellings[i].ddn_count = 0;
		modefiedArray2.push(unmatchedDwellings[i]);
	  }
  }

  let ccount = 0;
  modefiedArray2 = _.uniqBy(modefiedArray2, "treeId");
  console.log(modefiedArray2, "modefiedArray2ff")
  return modefiedArray2
}
let polygon;

function addZipprBeforeLayer(geoJsonLayer, spaceValue, parentValue) {
  console.log(geoJsonLayer, spaceValue, "spaceValue++spaceValue")

  let zipprBeforePolygonArray = [];
  geoJsonLayer.map((ele) => {
    if (spaceValue == ele.city_id && ele.properties.parentValue == parentValue) {
      zipprBeforePolygonArray.push(ele);
    }
  })
  let time = 0;
  let geojson = {};
  geojson.type = "FeatureCollection";
  geojson.features = zipprBeforePolygonArray;

  console.log(geojson, "geojson++")
if(polygon){
  var polygon = geojson.features[0];
  var centeroid = polygonCenter(polygon.geometry);
  let centerofPolygon = centeroid.coordinates
  console.log(centerofPolygon, "centerofPolygon in polygon");
  if (self) {
    self.setState({
      zipprsLayerCenteroid: centerofPolygon
    })

  }
}
  if (map.getLayer('zipprsBefore-layer')) {
    map.removeLayer('zipprsBefore-layer');
    time = 500
  }
  if (map.getSource('zipprsBefore-polygonSource')) {
    map.removeSource('zipprsBefore-polygonSource');
    time = 500
  }
  setTimeout(() => {

    map.addSource('zipprsBefore-polygonSource', {
      "type": "geojson",
      "data": geojson
    })



    map.addLayer({
      'id': 'zipprsBefore-layer',
      'type': 'fill',
      'source': 'zipprsBefore-polygonSource',
      // 'source': {
      //   'type': 'geojson',
      //   'data': geojson,
      // },
      'layout': {},
      'paint': {
        // 'fill-color': getColor(th.state.firstLayerGeoJson.features[0].properties.diss_me),
        'fill-color': [
          'interpolate',
          ['linear'],
          ['get', 'ddn_count'],
          1,
          '#FFEDA0',
          100,
          '#FED976',
          1000,
          '#FEB24C',
          5000,
          '#FD8D3C',
          10000,
          '#FC4E2A',
          20000,
          '#E31A1C',
          25000,
          '#BD0026',
          50000,
          '#800026',
          500000,
          '#800026',
        ],
        'fill-opacity': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          1,
          0.5
        ]
      }
    });
  }, time)

}



function addLayer(layer, borderLayer, layerData) {

  map.addLayer({
    'id': layer,
    'type': 'fill',
    'source': {
      'type': 'geojson',
      'data': layerData,
    },
    'layout': {},
    'paint': {
      // 'fill-color': getColor(th.state.firstLayerGeoJson.features[0].properties.diss_me),
      'fill-color': [
        'interpolate',
        ['linear'],
        ['get', 'ddn_count'],
        1,
        '#FFEDA0',
        100,
        '#FED976',
        1000,
        '#FEB24C',
        5000,
        '#FD8D3C',
        10000,
        '#FC4E2A',
        20000,
        '#E31A1C',
        25000,
        '#BD0026',
        50000,
        '#800026',
        500000,
        '#800026',
      ],
      'fill-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        1,
        0.5
      ]
    }
  });

  map.addLayer({
    'id': borderLayer,
    'type': 'line',
    'source': {
      'type': 'geojson',
      'data': layerData,
    },
    'layout': {},
    'paint': {
      'line-color': '#0d2d8f',
      'line-width': 2
    }
  });
}


let _workOrder = localStorage.getItem("workOrderObj");
_workOrder = JSON.parse(_workOrder);
let previousLayer;
let hierarchyLevels;
if (_workOrder) {
  hierarchyLevels = _workOrder.hierarchy;
  if (hierarchyLevels.length == 3) {
    previousLayer = 'third-layer';
  } else if (hierarchyLevels.length == 4) {
    previousLayer = 'fourth-layer';
  }
  else if (hierarchyLevels.length == 5) {
    previousLayer = 'fifth-layer';
  }
}

let workOrder = localStorage.getItem("workOrderObj");
workOrder = JSON.parse(workOrder);
let work_order;
let hierarchyArray;
if (workOrder) {
  work_order = workOrder.workOrder;
} else {
  work_order = '';
}
let spaceKey;
if(workOrder){
   spaceKey = workOrder.hierarchy;
   hierarchyArray=workOrder.hierarchy;
}

let callSecondLayerCount=0;
let callThirdLayerCount=0;

export default class Map extends React.Component {
  constructor(props) {
    super(props)
    // const [workOrderClient, setWorkOrderClient] = useState("");
    this.state = {
      firstLayerGeoJson: "",
      initialLayerGeoJsonObject: "",
      clickedState: "",
      secondLayerGeoJson: "",
      thirdLayerGeoJson: "",
      fourthLayerGeoJson: "",
      fifthLayerGeoJson: "",
      selectedProject: metaData[0],
      sessionToken: "",
      initialDisplayDataArr: "",
      layer1_displayDataArr: [],
      layer2_displayDataArr: [],
      _layer2_displayDataArr: [],
      layer3_displayDataArr: [],
      _layer3_displayDataArr: [],
      layer4_displayDataArr: [],
      layer5_displayDataArr: [],
      zipprs_displayDataArr: [],
      layerdisplayDataArr1: [],
      zipprs: [],
      titel: "State",
      center: [],
      label: "",
      presentLayer: 1,
      zipprsData: "",
      zippr_image: "",
      display_zippr_data: false,
      map_upSideShowing_layers: [],
      map_upSideShowing_layers_new: [],
      showSidePane: false,
      initialCenter: [79.7400, 15.907],
      date_filter: "",
      startDate: new Date(),
      endDate: new Date(),
      WorkOrderClients: [],
      agencyFilterId: "",
      ddnValue: "",
      geoJsonObjFeaturesLayer3: "",
      // styleOfMap: "mapbox://styles/mapbox/streets-v11",
      loadCount: false,
      loadMap: false,
      zipprsLayerCenteroid: [],
      showDownloadLink: false,
      downloadBtnData:"",
      downloadArray:[],
      headers:[],
      loadDownloadButton:false,
      spaceValue: null,
      parentValue: null,
      buildingType: null,
      buildingTypeFilter: false,
      markedZipprs:[],
      styleOfMap:
    //  'mapbox://styles/mapbox/streets-v9',
      {
        'version': 8,
        'sources': {
            'raster-tiles': {
                'type': 'raster',
                'tiles': [
                    'https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoidmVudWdvcGFhbCIsImEiOiJjazNmZml1bmYwM3FpM25vemh3cnlmOXR0In0.AdnqIyCvzVQYas34CcDwvg'
                ],
                'tileSize': 256,
                'attribution':
                    '&copy; <a target="_top" rel="noopener" href="https://www.mapbox.com/about/maps/">Mapbox</a> &copy; <a target="_top" rel="noopener" href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }
        },
        'layers': [
            {
                'id': 'simple-tiles',
                'type': 'raster',
                'source': 'raster-tiles',
                'minzoom': 0,
                'maxzoom': 22
            }
        ]
    },
    timeKey:'lifetime',
    }
    this.titelClick = this.titelClick.bind(this);
    this.toggleLeftPaneButton = this.toggleLeftPaneButton.bind(this);
    this.dateFilter = this.dateFilter.bind(this);
    this.getAnalytics=this.getAnalytics.bind(this);
    this.searchClick = this.searchClick.bind(this);
    // this.mapStyleChange = this.mapStyleChange.bind(this);
    this.checkIsDownloadLinkShow = this.checkIsDownloadLinkShow.bind(this);
    this.checkIsDownloadLinkShowNew=this.checkIsDownloadLinkShowNew.bind(this);
    this.addPolygonLayer=this.addPolygonLayer.bind(this);
    this.addCommonLayer=this.addCommonLayer.bind(this);
    this.mapUpperBar=this.mapUpperBar.bind(this);
    this.addZipprsLayer=this.addZipprsLayer.bind(this);
    this.addBorder=this.addBorder.bind(this);

     th = this;

  }




  componentWillMount() {

  }
  componentWillUnmount() {
    let params = this.state.selectedProject.analytics_layer_1;
    let param = params.params;
    param.timeKey = 'lifetime';
    param.userKey = 'allClients';
    param.clientId = '';
    addDates(param);
    param.toDate = "";

    let zipprParams=this.state.selectedProject.zipprs_layer.params;
    zipprParams.timeKey = 'lifetime';
    zipprParams.userKey = 'allClients';
    zipprParams.clientId = '';
    addDates(param);
    zipprParams.toDate = "";
    zipprParams.fromDate="";

  }


  componentDidMount() {
    console.log(spaceKey,work_order,"++++===");
    console.log(workOrder,"++++===++")

    let analyticsParams={...this.state.selectedProject.analytics_layer_1.params};
    analyticsParams.spaceKey=spaceKey[0];
    analyticsParams.work_order=work_order;


    let polygonParams=this.state.selectedProject.polygonLayer.params
    polygonParams.label=spaceKey[0];
    // this.addPolygonLayer(polygonParams);
    this.getAnalytics(analyticsParams,polygonParams);

    axios.get(this.state.selectedProject.workOrderClients.url, {
      params: this.state.selectedProject.workOrderClients.params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        let workOrderClientsData = res.data.response.clientObjs;
        let clientObjectAyyay = [];
        workOrderClientsData.map((client) => {
          let clientObject = {
            name: client.app_name,
            id: client._id
          }
          clientObjectAyyay.push(clientObject);
        })
        this.setState({
          WorkOrderClients: clientObjectAyyay
        })

      })

this.addMap();

if(map){
map.on('click', "common-layer", function (e) {
  let requiredData = {
    name: e.features[0].properties.name,
    layerId: e.features[0].layer.id,
  }
  console.log(e.features[0].properties,"e.features[0].properties");
  if(e.features[0].properties){
    let label=e.features[0].properties.label;
    let space=e.features[0].properties.space;
    space=JSON.parse(space);
    console.log(space,"spacepp")
    let spaceKeys=space[label];
    let parentKey=label;
    let parentValue=spaceKeys.id;
    console.log(spaceKeys,"spaceKeysll")
    console.log(parentKey,parentValue, "spacee");
    let analyticsParams={...th.state.selectedProject.analytics_layer_1.params};
    analyticsParams.parentKey=parentKey;
    analyticsParams.parentValue=parentValue;
    analyticsParams.spaceKey="";
    analyticsParams.spaceValue="";
    // analyticsParams.timeKey='lifetime';
    let polygonParams={...th.state.selectedProject.polygonLayer.params};
    polygonParams.parentKey=parentKey;
    polygonParams.parentValue=parentValue;
    // polygonParams.label=spaceKey[0];

   let nextLabel= getNextLabel(label,hierarchyArray);
   let prevLabel=getPreviousLabel(label,hierarchyArray);
   if(nextLabel){
    polygonParams.label=nextLabel;
      th.getAnalytics(analyticsParams,polygonParams);
   }else{
    let zipprsParams = th.state.selectedProject.zipprs_layer.params;
    zipprsParams.spaceValue = parentValue;
    zipprsParams.spaceKey = parentKey;
    // let prevLabel=getPreviousLabel(label,hierarchyArray);
    // zipprsParams.timeKey='lifetime';
    console.log(prevLabel,"prevLabel++0");
    if(prevLabel){
    zipprsParams.parentKey=prevLabel;
    zipprsParams.parentValue=space[prevLabel].id;
    }
    //  th.addZipprsLayer(zipprsParams);
     console.log(zipprsParams,"call zipprs...");
     console.log(analyticsParams,polygonParams,"analyticsParams,polygonParamszipprs");
     let borderParams={...th.state.selectedProject.polygonLayer.params};
     borderParams.label=parentKey;
     borderParams.spaceKey=parentKey;
     borderParams.spaceValue=parentValue;
     borderParams.parentKey=prevLabel;
     borderParams.parentValue=space[prevLabel].id;
     let zipprsdatParams={...th.state.selectedProject.analytics_layer_1.params};
     zipprsdatParams.spaceKey=parentKey;
     zipprsdatParams.spaceValue=parentValue;
    //  let prevLabel=getPreviousLabel(parentKey,hierarchyArray);
    if(prevLabel){
     zipprsdatParams.parentKey=prevLabel;
     zipprsdatParams.parentValue=space[prevLabel].id;
    }
console.log(zipprsdatParams,borderParams,"zipprsdatParams,borderParams")
     th.getAnalytics(zipprsdatParams,borderParams,"zipprs-Layer");
     setTimeout(()=>{
      th.addZipprsLayer(zipprsParams);
     },1000)
   }

   let upsideTitles=[...th.state.map_upSideShowing_layers_new];
   let parentUp;
   if(prevLabel){
    parentUp=space[prevLabel].id;
}
   let upTitles={};
upTitles.name=spaceKeys.name;
upTitles.parentKey=prevLabel ? prevLabel : "";
upTitles.parentValue=parentUp?parentUp:"";
upTitles.analyticsParams=analyticsParams;
upTitles.polygonParams=polygonParams;
upTitles.label=label;
var index = hierarchyArray.indexOf(parentKey);
console.log(hierarchyArray[0],parentKey,"ssddkk");
upsideTitles[index]=upTitles;
    th.setState({
      map_upSideShowing_layers_new:upsideTitles,
    })

  }
  map.getCanvas().style.cursor = '';
  popup.remove();

})
  }

  }

  componentDidUpdate(){
    if(this.state.buildingType && !this.state.buildingTypeFilter){
      if(this.state.buildingType === "all"){
        this.addZipprsLayer({...this.state.selectedProject.zipprs_layer.params, spaceValue: this.state.spaceValue, parentValue: this.state.parentValue});
      } else {
        this.addZipprsLayer({...this.state.selectedProject.zipprs_layer.params, spaceValue: this.state.spaceValue, parentValue: this.state.parentValue});
      }
      this.setState({
        buildingTypeFilter: true
      })
    }
  }

  addMap(e) {
    const container = document.getElementById('map');
    mapboxgl.accessToken = 'pk.eyJ1IjoidmVudWdvcGFhbCIsImEiOiJjazNmZml1bmYwM3FpM25vemh3cnlmOXR0In0.AdnqIyCvzVQYas34CcDwvg';
    if (container) {
        map = new mapboxgl.Map({
            container: 'map', // container id
            style: this.state.styleOfMap, // stylesheet location
            center: [79.7400, 15.907], // starting position [lng, lat]
            zoom: 4 // starting zoom
        });
        if (map) {
          map.addControl(nav, 'bottom-left');
        }
    }
    map.on('load', function () {
      if(work_order === "OD1"){
        map.addSource('wms-test-source', {
          'type': 'raster',
          // use the tiles option to specify a WMS tile source URL
          // https://docs.mapbox.com/mapbox-gl-js/style-spec/sources/
          'tiles': [
            // 'https://img.nj.gov/imagerywms/Natural2015?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=256&height=256&layers=Natural2015'
            'https://odishaimage.orsac.gov.in/erdas-apollo/coverage/BLUIS_SATELLITE_20210201?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&CRS=EPSG:3857&WIDTH=668&HEIGHT=605&LAYERS=satellite_20210201&STYLES=default&FORMAT=image/png&DPI=72&MAP_RESOLUTION=72&FORMAT_OPTIONS=dpi:72&TRANSPARENT=TRUE&BBOX={bbox-epsg-3857}'
            // 'https://bluis.odisha.gov.in/geoserver/BLUIS/wms?authkey=24eacd67-6759-4b3e-a5ef-0e9a79a451a1&SERVICE=WMS&VERSION=1.1.1&REQUEST=GetMap&SRS=EPSG:3857&WIDTH=700&HEIGHT=659&LAYERS=satellite_mosaic&STYLES=raster&FORMAT=image/png&DPI=72&MAP_RESOLUTION=72&FORMAT_OPTIONS=dpi:72&TRANSPARENT=TRUE&BBOX={bbox-epsg-3857}'
          ],
          'tileSize': 256
        });
        map.addLayer(
        {
          'id': 'wms-test-layer',
          'type': 'raster',
          'source': 'wms-test-source',
          'paint': {}
        },
          // 'aeroway-line'
        );
      }
    });
}

getAnalytics(analyticsParams,polygonParams,zipprsLayer){
console.log(analyticsParams,"analytics params");
// analyticsParams.timeKey='lifetime';
this.setState({
  loadMap:true
})

  axios.get(this.state.selectedProject.analytics_layer_1.url, {
    params: analyticsParams,
    headers: this.state.selectedProject.headers
  })
    .then(res => {
      console.log(res.data,"analy respooo")
      analyticsResponse = res.data.response.analyticsDocs;
      let response = res.data.response.analyticsDocs;
      console.log(response,"response analyy");
      let layer1_displayDataArr = [];
      let layer2_displayDataArr = [];
      response.map((ele) => {
        // if (ele.space.key == workOrder.hierarchy[0] && ele.space.value == this.state.selectedProject.project) {
          // console.log(ele, "eleeee....++")
          layer1_displayDataArr.push({
            ddn_count: ele.count.ddn,
            display_name: ele.space.name,
            zp_type: ele.zp_type,
            parent: ele.space.parent ? ele.space.parent.name : "",
            treeId: ele.treeId,
            name: ele.space.value,
            space:ele.space,
            // layer: 'first-layer'
          })

      })
      console.log(layer1_displayDataArr, "layer1_displayDataArrrty")


      layer1_displayDataArr = filteredArray(layer1_displayDataArr);

      // let filteredArr2 = filteredArray(layer2_displayDataArr);
      layer1_displayDataArr = layer1_displayDataArr;
      this.checkIsDownloadLinkShowNew(layer1_displayDataArr);
      this.setState({
        layer1_displayDataArr: layer1_displayDataArr,
        initialDisplayDataArr: layer1_displayDataArr,
        // layer2_displayDataArr: filteredArr2,
        // _layer2_displayDataArr: filteredArr2
      },()=>{
        if(zipprsLayer){
          this.addPolygonLayer(polygonParams,zipprsLayer);
        }else{
          this.addPolygonLayer(polygonParams);
        }

      })
    })
}

addPolygonLayer(params,zipprsLayer){

  axios.get(this.state.selectedProject.polygonLayer.url, {
    params: params,
    headers: this.state.selectedProject.headers
  })
    .then(res => {
      let persons = res.data.response.StaticClusters;
      console.log(persons,"static clusters resp")
      let geoJsonObj = {};
      geoJsonObj.type = "FeatureCollection";
      geoJsonObj.features = [];
      let id = 1;
      persons.map((ele) => {
        console.log(ele,"eleewwwr")
        let label= ele.label;
        geoJsonObj.features.push(
          {
            type: "Feature",
            geometry: ele.geometry,
            properties: {
              name: ele.workOrder,
              popupName: ele.space[label].name,
              space:ele.space,
              label:ele.label
            },
            state_name: ele.space[label].name,
            _id: ele._id,
            id: id++
          }
        )
      })
console.log(geoJsonObj,"geoJsonObj++=+")
      let filteredgeoJsonObj = [];
      this.state.layer1_displayDataArr.map((ele) => {
        //ele.display_name
        geoJsonObj.features.map((element) => {
          if (ele.display_name == element.state_name) {
            filteredgeoJsonObj.push(element)

            if (element.geometry.coordinates[0][0].length == 2) {
              // var polygon;
              // if (element.geometry.coordinates.length > 1) {
              //   element.geometry.type = 'MultiPolygon';
              //   polygon = turf.multiPolygon(element.geometry.coordinates);
              // } else {
              //   polygon = turf.polygon(element.geometry.coordinates);
              // }
              // // var polygon = turf.polygon(element.geometry.coordinates);
              // var center = turf.centerOfMass(polygon);
              // ele.co_ordinates = center.geometry.coordinates;


              //  ele.co_ordinates = element.geometry.coordinates[0][0];
            }
            // else if (element.geometry.coordinates[0][0][0]) {
              // if (element.geometry.coordinates[0][0][0].length == 2) {

                // var polygon;
                // if (element.geometry.coordinates.length > 1) {
                //   element.geometry.type = 'MultiPolygon';
                //   polygon = turf.multiPolygon(element.geometry.coordinates);
                // } else {
                //   polygon = turf.polygon(element.geometry.coordinates);
                // }

                // var polygon = turf.polygon(element.geometry.coordinates[0]);
                // var center = turf.centerOfMass(polygon);
                // ele.co_ordinates = center.geometry.coordinates;

                //  ele.co_ordinates = element.geometry.coordinates[0][0][0];
              // }
            // }

            // ele.co_ordinates = element.geometry.coordinates[0][0][0];
            element.properties.ddn_count = ele.ddn_count;
          }
        })

      });

      this.setState({
        layerdisplayDataArr1: this.state.layer1_displayDataArr
      })

      geoJsonObj.features = filteredgeoJsonObj;

      if (filteredgeoJsonObj[0]) {
        initialCenter = filteredgeoJsonObj[0].geometry.coordinates[0][0];
      }
      console.log(geoJsonObj,"geoJsonObj++")
      this.setState({
        firstLayerGeoJson: geoJsonObj,
        initialLayerGeoJsonObject: geoJsonObj,
        initialCenter: initialCenter
      },()=>{
        if(zipprsLayer){
          this.addCommonLayer("","common-layer-border",geoJsonObj);
        }else{
          this.addCommonLayer("common-layer","common-layer-border",geoJsonObj);
        }
      });
    })

}

addBorder(border,layerData){
  removePrevLayer(border,"bordersource");
  map.addSource('bordersource', {
    "type": "geojson",
    "data": layerData,
});

  map.addLayer({
    'id': border,
    'type': 'line',
    'source':'bordersource',
    // 'source': {
    //   'type': 'geojson',
    //   'data': layerData,
    // },
    'layout': {},
    'paint': {
      'line-color': '#0d2d8f',
      'line-width': 2
    }
  });
}

addCommonLayer(layer,border,layerData){

  popup = new mapboxgl.Popup({
    closeButton: false,
    closeOnClick: false
  });
if(layer){
  removePrevLayer(layer,"layersource");
  // map.on('load', function () {
  map.addSource('layersource', {
    "type": "geojson",
    "data": layerData,
});

  map.addLayer({
    'id': layer,
    'type': 'fill',
    'source':'layersource',
    // 'source': {
    //   'type': 'geojson',
    //   'data': layerData,
    // },
    'layout': {},
    'paint': {
      // 'fill-color': getColor(th.state.firstLayerGeoJson.features[0].properties.diss_me),
      // 'fill-color': {
      //   property: 'count',
      //   stops: [[100, '#FFEDA0'], [200, '#FED976'],[500, '#FC4E2A'],[1000, '#E31A1C'],[3000, '#800026']]
      //   },
      'fill-color': [
        'interpolate',
        ['linear'],
        ['get', 'ddn_count'],
        1,
        '#FFEDA0',
        100,
        '#FED976',
        1000,
        '#FEB24C',
        5000,
        '#FD8D3C',
        10000,
        '#FC4E2A',
        20000,
        '#E31A1C',
        25000,
        '#BD0026',
        50000,
        '#800026',
        500000,
        '#800026',
      ],
      // 'fill-color': '#8a0108',
      'fill-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        1,
        0.7
      ]
    }
  });
}

  removePrevLayer(border,"bordersource");
  map.addSource('bordersource', {
    "type": "geojson",
    "data": layerData,
});

  map.addLayer({
    'id': border,
    'type': 'line',
    'source':'bordersource',
    // 'source': {
    //   'type': 'geojson',
    //   'data': layerData,
    // },
    'layout': {},
    'paint': {
      'line-color': '#0d2d8f',
      // 'line-color': 'red',
      'line-width': 2
    }
  });
console.log(layerData,"layerDatannn");
if(layerData.features.length){
  var boundCoordinates = [...layerData.features[0].geometry.coordinates];

  // if(boundCoordinates.length==1){
  //   boundCoordinates=boundCoordinates[0];
  // }
  if(boundCoordinates.length==1){
    boundCoordinates=boundCoordinates[0];
}else if(boundCoordinates[0].length==1){
    boundCoordinates=boundCoordinates[0][0];
}else{
  boundCoordinates=boundCoordinates;
}
if(boundCoordinates.length==1){
  boundCoordinates=boundCoordinates[0]
}
console.log(boundCoordinates,"boundCoordinates++00");

  var bounds = boundCoordinates.reduce(function (bounds, coord) {
    return bounds.extend(coord);
   // }, new mapboxgl.LngLatBounds(boundCoordinates[0], boundCoordinates[0]));
    }, new mapboxgl.LngLatBounds((boundCoordinates[0].length <= 3 ? boundCoordinates[0] : boundCoordinates[0][0]), (boundCoordinates[0].length <= 3 ? boundCoordinates[0] : boundCoordinates[0][0])));

    console.log(bounds,"boundsjjj")
if(layerData.features[0].geometry.type=="MultiPolygon"){
  if(boundCoordinates[0].length==2){
    map.flyTo({
      center: boundCoordinates[0],
      zoom: 5
    });
  }

}else{
  map.fitBounds(bounds, {
    padding: 20
    });
  }
}

      if(layer){
      // map.on('load', function () {
//       map.on('click', layer, function (e) {

//         let requiredData = {
//           name: e.features[0].properties.name,
//           layerId: e.features[0].layer.id,
//         }
//         console.log(e.features[0].properties,"e.features[0].properties");
//         if(e.features[0].properties){
//           let label=e.features[0].properties.label;
//           let space=e.features[0].properties.space;
//           space=JSON.parse(space);
//           console.log(space,"spacepp")
//           let spaceKeys=space[label];
//           let parentKey=label;
//           let parentValue=spaceKeys.id;
//           console.log(spaceKeys,"spaceKeysll")
//           console.log(parentKey,parentValue, "spacee");
//           let analyticsParams={...th.state.selectedProject.analytics_layer_1.params};
//           analyticsParams.parentKey=parentKey;
//           analyticsParams.parentValue=parentValue;
//           analyticsParams.timeKey='lifetime';
//           let polygonParams={...th.state.selectedProject.polygonLayer.params};
//           polygonParams.parentKey=parentKey;
//           polygonParams.parentValue=parentValue;
//           // polygonParams.label=spaceKey[0];

//          let nextLabel= getNextLabel(label,hierarchyArray);
//          if(nextLabel){
//           polygonParams.label=nextLabel;
//             th.getAnalytics(analyticsParams,polygonParams);
//          }else{
//           let zipprsParams = th.state.selectedProject.zipprs_layer.params;
//           zipprsParams.spaceValue = parentValue;
//           zipprsParams.spaceKey = parentKey;
//           let prevLabel=getPreviousLabel(label,hierarchyArray);
//           zipprsParams.timeKey='lifetime';
//           console.log(prevLabel,"prevLabel++0");
//           if(prevLabel){
//           zipprsParams.parentKey=prevLabel;
//           zipprsParams.parentValue=space[prevLabel].id;
//           }
//            th.addZipprsLayer(zipprsParams);
//            console.log(zipprsParams,"call zipprs...");
//            console.log(analyticsParams,polygonParams,"analyticsParams,polygonParamszipprs");
//            let borderParams={...th.state.selectedProject.polygonLayer.params};
//            borderParams.label=parentKey;
//            borderParams.spaceKey=parentKey;
//            borderParams.spaceValue=parentValue;
//            borderParams.parentKey=prevLabel;
//            borderParams.parentValue=space[prevLabel].id;
//            let zipprsdatParams={...th.state.selectedProject.analytics_layer_1.params};
//            zipprsdatParams.spaceKey=parentKey;
//            zipprsdatParams.spaceValue=parentValue;
//           //  let prevLabel=getPreviousLabel(parentKey,hierarchyArray);
//           if(prevLabel){
//            zipprsdatParams.parentKey=prevLabel;
//            zipprsdatParams.parentValue=space[prevLabel].id;
//           }
// console.log(zipprsdatParams,borderParams,"zipprsdatParams,borderParams")
//            th.getAnalytics(zipprsdatParams,borderParams,"zipprs-Layer");

//          }

//          let upsideTitles=[...th.state.map_upSideShowing_layers_new];

//          let upTitles={};
//     upTitles.name=spaceKeys.name;
//     upTitles.analyticsParams=analyticsParams;
//     upTitles.polygonParams=polygonParams;
//     upTitles.label=label;
//     var index = hierarchyArray.indexOf(parentKey);
// console.log(hierarchyArray[0],parentKey,"ssddkk");
//    upsideTitles[index]=upTitles;
//           th.setState({
//             map_upSideShowing_layers_new:upsideTitles,
//           })

//         }
//         map.getCanvas().style.cursor = '';
//         popup.remove();

//       })

    // })

    map.on('mouseenter', layer, () => {
      map.getCanvas().style.cursor = 'pointer'
    })

    map.on('mousemove', layer, function (e) {
      var description = e.features[0].properties.description;
      var coordinates = e.features[0].geometry.coordinates.slice();
      popup
        .setLngLat(e.lngLat)
        .setHTML("<b>" + e.features[0].properties.popupName + "</b>" + "<br />" +
          "<span>" + e.features[0].properties.ddn_count + " Buildings" + "</span>"
        )
        .addTo(map);
    });

    map.on('mouseleave', layer, function () {
      map.getCanvas().style.cursor = '';
      popup.remove()
    });

}

this.setState({
  loadMap:false
})

    // })

}

addZipprsLayer(params){
  console.log(params,"hereparams")
  this.setState({
    loadMap:true
  })
let responseZipprs = "";
let mainObj = {};
let reqParams = null;
if(this.state.date_filter == 'custom'){
  reqParams = {
    ...params,
    fromDate: this.state.startDate.toLocaleDateString().replace(/\b\d\b/g, '0$&').replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3-$2-$1"),
    toDate: this.state.endDate.toLocaleDateString().replace(/\b\d\b/g, '0$&').replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3-$2-$1")
  }
} else {
  reqParams = params
}
if(this.state.buildingType){
  if(this.state.buildingType === "all"){
    reqParams.buildingType = ""
  } else {
    reqParams.buildingType = this.state.buildingType
  }
}
axios.get(this.state.selectedProject.zipprs_layer.url, {
  params: reqParams,
  headers: this.state.selectedProject.headers
})
  .then(res => {
    console.log(res,"calling zipprs layer")

    //let persons = res.data.response.StaticClusters;
    responseZipprs = res.data.response.zipprObjs;
    let buildingsArr = [];
    let dwellingsArr = [];
    removePrevLayer('common-layer',"layersource");

    responseZipprs.map(zippr => {
      if (zippr.zp_type == 7) {
        buildingsArr.push(zippr);
      } else if (zippr.zp_type == 8) {
        dwellingsArr.push(zippr);
      }
    })
console.log(buildingsArr,dwellingsArr,"buildanddwill");
var buildingsArrZipprs = buildingsArr.map(function(i) {
  return i.zippr;
});
console.log(buildingsArrZipprs,"buildingsArrZipprs")
    let zipprsDisplayData = [{
      display_name: 'Total Buildings',
      ddn_count: buildingsArr.length,
      dwellings: dwellingsArr.length,

    }]
    this.setState({
      layer1_displayDataArr: zipprsDisplayData,
      zipprs_displayDataArr: zipprsDisplayData,
      titel: "DDN's:",
      // map_upSideShowing_layers: map_upSideShowing_layers,
      presentLayer: 4,
      markedZipprs:buildingsArrZipprs
    })


    // let mainObj = {};

    let geoJsonObjArray = [];

    //  geoJsonObj.type= "Feature";
    let assign = {}
    buildingsArr.map((ele) => {

      let geoJsonObj = {};
      geoJsonObj.geometry = {};
      geoJsonObj.properties = {};

      geoJsonObj.type = "Feature";
      geoJsonObj.geometry.type = "Point";
      geoJsonObj.properties.ethnicity = ele.metadata_props_status;
      geoJsonObj.geometry.coordinates = ele.location.coordinates;
      geoJsonObj.properties.holeZipprData = ele

      // geoJsonObj.properties.modelId=1;
      geoJsonObjArray.push(geoJsonObj)

      // Object.assign( assign, geoJsonObj );
    })


    mainObj.features = geoJsonObjArray;
    mainObj.type = "FeatureCollection"


    this.setState({
      zipprs: mainObj
    })
  }).then(res => {
    removePrevLayer('zipprs-layer','markers3');
    map.addSource('markers3', {
      "type": "geojson",
      "data": mainObj

    });

    if (_workOrder) {
      if (_workOrder.workOrder == 'ND') {


    map.addLayer({
      "id": "zipprs-layer",
      "source": "markers3",
      "type": "circle",
      "paint": {
        'circle-color': [
          'match',
          ['get', 'ethnicity'],
          1,
          '#006400',
          2,
          '#ff7800',
        /* other */ '#e50000'
        ],
        "circle-radius": 3.5,
        "circle-opacity": 0.8,
        // "circle-stroke-width": 1,
        // "circle-stroke-color": "#ff7800",
        // "circle-stroke-opacity": 1,
        // 'circle-color': '#ff7800'
      },
      // "filter": ["==", "modelId", 2],
    });
  }else{
    map.addLayer({
      "id": "zipprs-layer",
      "source": "markers3",
      "type": "circle",
      "paint": {
        "circle-radius": 3.5,
        "circle-opacity": 0.8,
        "circle-stroke-width": 0.5,
        "circle-stroke-color": "#ff7800",
        "circle-stroke-opacity": 1,
        'circle-color': '#ff7800'
      },
      // "filter": ["==", "modelId", 2],
    });
  }
}
    map.on('mouseenter', 'zipprs-layer', () => {
      map.getCanvas().style.cursor = 'pointer'
    })
    map.on('mousemove', 'zipprs-layer', function (e) {
      var description = e.features[0].properties.description;
      var coordinates = JSON.parse(e.features[0].properties.holeZipprData)
      popup
        .setLngLat(e.lngLat)
        .setHTML("<b>" + "Zippr-Address" + "</b>" + "<br />" +
          "<span>" + coordinates.zippr + "</span>"
        )
        .addTo(map);
    });

    map.on('mouseleave', 'zipprs-layer', function () {
      map.getCanvas().style.cursor = '';
      popup.remove()
    });

    map.on('click', 'zipprs-layer', function (e) {
      let data = e.features[0].properties.holeZipprData;
      let jsonData = JSON.parse(data);
      jsonData.imageLoading = true;
      let zippr_image;
      if (jsonData.zippr_media) {
        zippr_image = jsonData.zippr_media.images[0].default.url ? jsonData.zippr_media.images[0].default.url : "";
      }
      th.setState({
        zipprsData: jsonData,
        zippr_image: zippr_image,
        display_zippr_data: true
      })

    })

    this.setState({
      loadMap:false
    })

    // map.flyTo({
    //   center: responseZipprs[0].location.coordinates,
    //   zoom: 18
    // });
  })
}

mapUpperBar(e){
let value=JSON.parse(e.target.name);
removePrevLayer('zipprs-layer','markers3');
this.setState({
  display_zippr_data:false,
  markedZipprs:[],
})
console.log(value,"vvggttt");
if(value.analyticsParams){
let spaceKey=value.analyticsParams.parentKey;
let spaceValue=value.analyticsParams.parentValue;
console.log(spaceKey,spaceValue,"spaceValueoop");
let analyticsParams={...th.state.selectedProject.analytics_layer_1.params};
analyticsParams.parentKey=value.parentKey?value.parentKey:"";
analyticsParams.parentValue=value.parentValue ? value.parentValue : "";
if(!value.parentValue){
analyticsParams.spaceKey=spaceKey;
analyticsParams.spaceValue=spaceValue;
}else{
  analyticsParams.spaceKey="";
analyticsParams.spaceValue="";
}

let polygonParams={...th.state.selectedProject.polygonLayer.params};
          polygonParams.parentKey=value.parentKey?value.parentKey:"";
          polygonParams.parentValue=value.parentValue ? value.parentValue : "";
         if(!value.parentKey){
          polygonParams.spaceKey=spaceKey;
          polygonParams.spaceValue=spaceValue;
         }else{
          analyticsParams.spaceKey="";
        analyticsParams.spaceValue="";
        }
          polygonParams.label=spaceKey;


console.log(analyticsParams,polygonParams,"polygonParamsllo");
 this.getAnalytics(analyticsParams,polygonParams);

  let result=removePreviousNamesInUpperBar(spaceKey,this.state.map_upSideShowing_layers_new);

  console.log(result,"resultpp");
  this.setState({
    map_upSideShowing_layers_new:result
  })

  // this.setState({
  //   map_upSideShowing_layers_new:result
  // })



}

}


  titelClick(e) {
    console.log(JSON.parse(e.target.name), "e.target.namein titleclick");
    let data = JSON.parse(e.target.name);
    let coOrdenates = data.co_ordinates;
    console.log(data, "aaaaaasssaaa");


    // let requiredData = {
    //   name: data.display_name,
    //   layerId: data.layer,
    //   treeId: data.treeId,
    //   parentValue: data.parentId,
    //   spaceValue: data.name
    // }
    if(data.space){
let parentKey=data.space.key;
let parentValue=data.name;
console.log(parentKey,parentValue,"parentValuelll");

let lastLevel=hierarchyArray[hierarchyArray.length-1];


let analyticsParams={...th.state.selectedProject.analytics_layer_1.params};
analyticsParams.parentKey=parentKey;
analyticsParams.parentValue=parentValue;
analyticsParams.spaceKey="";
    analyticsParams.spaceValue="";
// analyticsParams.timeKey='lifetime';
let polygonParams={...th.state.selectedProject.polygonLayer.params};
polygonParams.parentKey=parentKey;
polygonParams.parentValue=parentValue;

console.log(analyticsParams,polygonParams,"parentKeyoopp");



      let nextLabel= getNextLabel(parentKey,hierarchyArray);
      let label=parentKey;
      let prevLabel=getPreviousLabel(label,hierarchyArray);
      let space=data.space;
         if(nextLabel){
          polygonParams.label=nextLabel;
            th.getAnalytics(analyticsParams,polygonParams);
         }else{
           console.log("call zipprs...");


           console.log(space,label,"space,label click")
           let zipprsParams = {...th.state.selectedProject.zipprs_layer.params};
           this.setState({spaceValue: parentValue})
           zipprsParams.spaceValue = parentValue;
           zipprsParams.spaceKey = parentKey;

          //  zipprsParams.timeKey='lifetime';
           console.log(prevLabel,"prevLabel++0");
           if(prevLabel){
           zipprsParams.parentKey=prevLabel;
           zipprsParams.parentValue=space.parent.value;
           this.setState({parentValue: space.parent.value})
           }
           console.log(zipprsParams,"zipprsParams click")

            console.log(analyticsParams,polygonParams,"analyticsParams,polygonParamszipprs");
            let borderParams={...th.state.selectedProject.polygonLayer.params};
            borderParams.label=parentKey;
            borderParams.spaceKey=parentKey;
            borderParams.spaceValue=parentValue;
            borderParams.parentKey=prevLabel;
            borderParams.parentValue=space.parent.value;
            let zipprsdatParams={...th.state.selectedProject.analytics_layer_1.params};
            zipprsdatParams.spaceKey=parentKey;
            zipprsdatParams.spaceValue=parentValue;
           //  let prevLabel=getPreviousLabel(parentKey,hierarchyArray);
           if(prevLabel){
            zipprsdatParams.parentKey=prevLabel;
            zipprsdatParams.parentValue=space.parent.value;
           }
 console.log(zipprsdatParams,borderParams,"zipprsdatParams,borderParams")
            th.getAnalytics(zipprsdatParams,borderParams,"zipprs-Layer");
           setTimeout(()=>{
            th.addZipprsLayer(zipprsParams);
           },1000)

         }

         let upsideTitles=[...th.state.map_upSideShowing_layers_new];

         let upTitles={};
    upTitles.name=data.display_name;
    upTitles.parentKey=prevLabel;
    upTitles.parentValue=space.parent.value;
    upTitles.analyticsParams=analyticsParams;
    upTitles.polygonParams=polygonParams;
    upTitles.label=parentKey;
    var index = hierarchyArray.indexOf(parentKey);
console.log(hierarchyArray[0],parentKey,"ssddkk");
   upsideTitles[index]=upTitles;
          th.setState({
            map_upSideShowing_layers_new:upsideTitles,
          })

// if(lastLevel!==parentKey){
//   th.getAnalytics(analyticsParams,polygonParams);
// }else{
//   console.log('last levell/')
// }

    // console.log(data.layer, "data.layerpp")

    // if (data.layer == 'first-layer') {
    //   this.callFirstLayer(requiredData);
    // } else if (data.layer == 'second-layer') {
    //   this.callSecondLayer(requiredData);
    // } else if (data.layer == 'third-layer') {
    //   this.callThirdLayer(requiredData);
    // } else if (data.layer == 'fourth-layer') {
    //   this.callFourthLayer(requiredData);
    // } else if (data.layer == 'fifth-layer') {
    //   this.callFifthLayer(requiredData);
    // }


    // console.log(e.target.name, "e.target.name==")
    // let zoom;
    // if (this.state.presentLayer == 1) {
    //   zoom = 6;
    // } else if (this.state.presentLayer == 3) {
    //   zoom = 14
    // } else if (this.state.presentLayer == 2) {
    //   zoom = 10
    // } else if (this.state.presentLayer == 4) {
    //   zoom = 15
    // } else if (this.state.presentLayer == 5) {
    //   zoom = 16
    // }
        }
  }



  toggleLeftPaneButton(e) {
    this.setState({
      showSidePane: !this.state.showSidePane
    })
  }



  dateFilter(e) {

    this.setState({
      date_filter: e.target.value

    })

  }
  searchClick(e) {
    e.preventDefault();
    removePrevLayer('search-ddn-border',"ddnsearch-polygonSource");
    removePrevLayer('zipprs-layers',"ddnsearchSource");
    removePrevLayer('zipprs-layer','markers3');
    this.setState({
      display_zippr_data:false,
      map_upSideShowing_layers_new:[],
      markedZipprs:[],
    })
    let polygonParams=this.state.selectedProject.polygonLayer.params
    let analyticsParams={...this.state.selectedProject.analytics_layer_1.params};
    if(!this.state.date_filter && !this.state.agencyFilterId){
      analyticsParams.spaceKey=spaceKey[0];
      analyticsParams.work_order=work_order;
      polygonParams.label=spaceKey[0];
      this.getAnalytics(analyticsParams,polygonParams);
    }else{
      console.log("entering to else...");
    this.setState({
      loadMap: true
    })
    let dateFilter = this.state.date_filter;
    let agencyFilter = this.state.agencyFilterId;
    // this.state.selectedProject.analytics_layer_1.params.timeKey
    localStorage.setItem("dateFilter", JSON.stringify(dateFilter));
    if (dateFilter || agencyFilter) {
      if (dateFilter) {
        this.state.selectedProject.analytics_layer_1.params.timeKey = dateFilter;
        // this.state.selectedProject.analytics_layer_2.params.timeKey = dateFilter;
        // this.state.selectedProject.analytics_layer_3.params.timeKey = dateFilter;
        // this.state.selectedProject.analytics_layer_4.params.timeKey = dateFilter;
        // this.state.selectedProject.analytics_layer_5.params.timeKey = dateFilter;

        this.state.selectedProject.zipprs_layer.params.timeKey = dateFilter;

        addDates(this.state.selectedProject.analytics_layer_1.params);
        // addDates(this.state.selectedProject.analytics_layer_2.params);
        // addDates(this.state.selectedProject.analytics_layer_3.params);
        // addDates(this.state.selectedProject.analytics_layer_4.params);
        // addDates(this.state.selectedProject.analytics_layer_5.params);
        addDates(this.state.selectedProject.zipprs_layer.params);


        if (dateFilter == 'today' || dateFilter == 'this_month') {
          this.state.selectedProject.analytics_layer_1.params.toDate = "";
          this.state.selectedProject.zipprs_layer.params.toDate = "";
        }

        // addDates(this.state.selectedProject.zipprs_layer.params);

        if (dateFilter == 'custom') {
          let fromDate = this.state.startDate.toLocaleDateString().replace(/\b\d\b/g, '0$&').replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3-$2-$1");
          let toDate = this.state.endDate.toLocaleDateString().replace(/\b\d\b/g, '0$&').replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3-$2-$1");
          this.state.selectedProject.analytics_layer_1.params.toDate = toDate;
          this.state.selectedProject.analytics_layer_1.params.fromDate = fromDate;
        }

      }

      if (this.state.agencyFilterId && this.state.agencyFilterId !== "all") {
        this.state.selectedProject.analytics_layer_1.params.userKey = "client";
        this.state.selectedProject.analytics_layer_1.params.clientId = this.state.agencyFilterId;
        // this.state.selectedProject.analytics_layer_2.params.userKey = "client";
        // this.state.selectedProject.analytics_layer_2.params.clientId = this.state.agencyFilterId;
        // this.state.selectedProject.analytics_layer_3.params.userKey = "client";
        // this.state.selectedProject.analytics_layer_3.params.clientId = this.state.agencyFilterId;
        // this.state.selectedProject.analytics_layer_4.params.userKey = "client";
        // this.state.selectedProject.analytics_layer_4.params.clientId = this.state.agencyFilterId;
        // this.state.selectedProject.analytics_layer_5.params.userKey = "client";
        // this.state.selectedProject.analytics_layer_5.params.clientId = this.state.agencyFilterId;

        this.state.selectedProject.zipprs_layer.params.userKey = "client";
        this.state.selectedProject.zipprs_layer.params.userValue = this.state.agencyFilterId;


      }
      if (this.state.agencyFilterId == "all") {
        this.state.selectedProject.analytics_layer_1.params.userKey = "allClients";
        this.state.selectedProject.analytics_layer_1.params.clientId = "";

        this.state.selectedProject.zipprs_layer.params.userKey = "";
        this.state.selectedProject.zipprs_layer.params.userValue = "";
      }

      // this.allGeoJsonLayers();

      //this.addGeoJsonLayers();

      // setTimeout(this.addGeoJsonLayers,100);
      //  this.addGeoJsonLayers();


    }



    map_upSideShowing_layers = [];
    layer1_count = 0;
    layer2_count = 0;
    layer3_count = 0;
    layer4_count = 0;
    layer5_count = 0;

    this.state.selectedProject.analytics_layer_1.params.spaceKey=spaceKey[0];
    this.state.selectedProject.analytics_layer_1.params.spaceValue=work_order;
    this.state.selectedProject.analytics_layer_1.params.label=spaceKey[0];
console.log(this.state.selectedProject.analytics_layer_1,"this.state.selectedProject.analytics_layer_1 search")
    this.setState({
      map_upSideShowing_layers: [],
      display_zippr_data: false,
      showSidePane: false,
      analytics_layer_1:this.state.selectedProject.analytics_layer_1,
      zipprs_layer:this.state.selectedProject.zipprs_layer,
    },()=>{
      this.getAnalytics(this.state.selectedProject.analytics_layer_1.params,polygonParams);
    })
  }
  }

  agencyFilterChange(e) {
    let agencyId = e.target.value;
    this.setState({
      agencyFilterId: agencyId
    })
  }
  enterDdnChange(e) {
    this.setState({
      ddnValue:  e.target.value.toUpperCase()
    })
  }

  // mapStyleChange(e) {
  //   layer1_count = 0;
  //   layer2_count = 0;
  //   layer3_count = 0;
  //   layer4_count = 0;
  //   layer5_count = 0;

  //   if (map) {
  //     // var nav = new mapboxgl.NavigationControl();
  //     map.removeControl(nav);
  //   }

  //   this.setState({
  //     display_zippr_data: false,
  //     map_upSideShowing_layers: [],
  //     clickedStyle: e.target.name
  //   })
  //   map_upSideShowing_layers = [];
  //   let mapStyle = e.target.name;
  //   if (mapStyle == "satellite") {
  //     this.setState({
  //       styleOfMap: 'mapbox://styles/mapbox/streets-v11'
  //     })

  //   } else if (mapStyle == "normal") {
  //     this.setState({
  //       styleOfMap: {
  //         'version': 8,
  //         'sources': {
  //           'raster-tiles': {
  //             'type': 'raster',
  //             'tiles': [
  //               'https://4.aerial.maps.api.here.com/maptile/2.1/maptile/newest/satellite.day/{z}/{x}/{y}/256/png?app_id=P4UEExcJ2GCOynv1KNIb&app_code=hFRd8KXFK-iMhbgwzqmDXA'
  //             ],
  //             'tileSize': 256,
  //             'attribution':
  //               'Map tiles by <a target="_top" rel="noopener" href="http://stamen.com">Stamen Design</a>, under <a target="_top" rel="noopener" href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a target="_top" rel="noopener" href="http://openstreetmap.org">OpenStreetMap</a>, under <a target="_top" rel="noopener" href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'
  //           }
  //         },
  //         'layers': [
  //           {
  //             'id': 'simple-tiles',
  //             'type': 'raster',
  //             'source': 'raster-tiles',
  //             'minzoom': 0,
  //             'maxzoom': 22
  //           }
  //         ]
  //       }
  //     })

  //   }

  //   setTimeout(() => {
  //     map.setStyle(this.state.styleOfMap);
  //   }, 10)
  //   setTimeout(() => {
  //     this.addGeoJsonLayers()
  //   }, 100)
  // }

  ddnSearchButton(e,data) {
    ddn_search_count++;
    let ddnSearchZipprData;
    let params = {
      zippr: this.state.ddnValue,
    };
    this.setState({
      // map_upSideShowing_layers_new:[],
    })
    axios.get(this.state.selectedProject.zipprDetails.url, {
      params: params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        if (res.data.ok == false) {
          console.log(res.data.error.reason, "rrreesssppooo");
          this.setState({
            showSidePane: false
          })
          toast.error(<b>{res.data.error.reason}</b>, {
            position: toast.POSITION.BOTTOM_LEFT
          });
        }else{
        if (res.data.response) {
          console.log(res.data.response,"res.data.response++");
          let space = res.data.response.zipprObj.space;
          let location = res.data.response.zipprObj.location;//make dynamic
          let keys = Object.keys(space);
          //let lastKey = keys[keys.length - 1];
          let lastKey = hierarchyLevels[hierarchyLevels.length - 1]
          let zipprsData = res.data.response.zipprObj
          map_upSideShowing_layers = [];


          let lastLabel=spaceKey[spaceKey.length-1];
          let parentLabel=getPreviousLabel(lastLabel,hierarchyArray);
    //       let analyticsParams={...this.state.selectedProject.analytics_layer_1.params};
    // analyticsParams.spaceKey=lastLabel;
    // analyticsParams.spaceValue=space[lastLabel].id;
    // analyticsParams.parentKey=parentLabel;
    // analyticsParams.parentValue=space[parentLabel].id;
    let polygonParams={...this.state.selectedProject.polygonLayer.params};
    polygonParams.label=lastLabel;
    polygonParams.spaceKey=lastLabel;
    polygonParams.spaceValue=space[lastLabel].id;
    polygonParams.parentKey=parentLabel;
    polygonParams.parentValue=space[parentLabel].id;
    // this.getAnalytics(analyticsParams,polygonParams);
if(!data){
  this.setState({
    map_upSideShowing_layers: [],
    map_upSideShowing_layers_new:[],
  })
}
          this.setState({
            // map_upSideShowing_layers: [],
            showSidePane: false,
            zipprsData: zipprsData,
            markedZipprs:[],
            // map_upSideShowing_layers_new:[],
            zippr_image: res.data.response.zipprObj.zippr_media ? res.data.response.zipprObj.zippr_media.images[0].default.url : ""
          })
          let geometry = {
            geometry: location
          }
          let featuresArray = [];
          featuresArray[0] = geometry;
          featuresArray[0].type = "Feature";
          featuresArray[0].properties = res.data.response.zipprObj;
          let zippr = {};
          zippr.features = featuresArray;
          zippr.type = "FeatureCollection";

          // map.setLayoutProperty('first-layer', 'visibility', 'none');
          // map.setLayoutProperty('first-layer-borders', 'visibility', 'none');
          // map.setLayoutProperty('zipprs-layer', 'visibility', 'none');
          map.flyTo({
            center: location.coordinates,
            zoom: 15
          });

          let geoJsonLayer = [];
          // if (previousLayer == 'third-layer') {
          // if (hierarchyLevels.length == 3) {
          //   this.state.thirdLayerGeoJson.features.map((ele) => {
          //     if (space[lastKey].name == ele.city_name) {
          //       geoJsonLayer.push(ele);
          //     }
          //   })
          //   // } else if (previousLayer == 'fourth-layer') {
          // } else if (hierarchyLevels.length == 2) {
          //   this.state.secondLayerGeoJson.features.map((ele) => {
          //     if (space[lastKey].name == ele.city_name) {
          //       geoJsonLayer.push(ele);
          //     }
          //   })
          //   // } else if (previousLayer == 'fifth-layer') {
          // }
          // else if (hierarchyLevels.length == 4) {
          //   this.state.fourthLayerGeoJson.features.map((ele) => {
          //     if (space[lastKey].name == ele.city_name) {
          //       geoJsonLayer.push(ele);
          //     }
          //   })
          //   // } else if (previousLayer == 'fifth-layer') {
          // } else if (hierarchyLevels.length == 5) {
          //   this.state.fifthLayerGeoJson.features.map((ele) => {
          //     if (space[lastKey].name == ele.city_name) {
          //       geoJsonLayer.push(ele);
          //     }
          //   })
          // }

          axios.get(this.state.selectedProject.polygonLayer.url, {
            params: polygonParams,
            headers: this.state.selectedProject.headers
          })
            .then(res => {
              console.log(res.data.ok,"databbhy");
              if(res.data.ok){
              let persons = res.data.response.StaticClusters;
              console.log(persons,"static clusters resp")
              let geoJsonObj = {};
              geoJsonObj.type = "FeatureCollection";
              geoJsonObj.features = [];
              let id = 1;
              persons.map((ele) => {
                console.log(ele,"eleewwwr")
                let label= ele.label;
                geoJsonObj.features.push(
                  {
                    type: "Feature",
                    geometry: ele.geometry,
                    properties: {
                      name: ele.workOrder,
                      popupName: ele.space[label].name,
                      space:ele.space,
                      label:ele.label
                    },
                    state_name: ele.space[label].name,
                    _id: ele._id,
                    id: id++
                  }
                )
              })
              removePrevLayer('search-ddn-border',"ddnsearch-polygonSource");
              map.addSource('ddnsearch-polygonSource', {
                "type": "geojson",
                "data": geoJsonObj
              })

              map.addLayer({
                'id': 'search-ddn-border',
                'type': 'line',
                'source': 'ddnsearch-polygonSource',
                'layout': {},
                'paint': {
                  'line-color': '#0d2d8f',
                  'line-width': 2
                }
              });
            }
            })

          // let geojson = {};
          // geojson.type = "FeatureCollection";
          // geojson.features = geoJsonLayer;

          // if (map.getLayer('ddnSearch-layer')) {
          //   // map.removeSource('ddnsearch-polygonSource');
          //   map.removeLayer('ddnSearch-layer');
          // };
          // if (map.getSource('ddnsearch-polygonSource')) {
          //   map.removeSource('ddnsearch-polygonSource');
          // }






          // if (map.getLayer('zipprs-layers')) {
          //   // if(map.getSource('zipprs-layers')){

          //   map.removeLayer('zipprs-layers');


          // };

          // if (map.getLayer('first-layer')) {
          //   map.removeLayer('first-layer');
          //   map.removeLayer('first-layer-borders');
          // };
          // if (map.getLayer('second-layer')) {
          //   map.removeLayer('second-layer');
          //   map.removeLayer('second-layer-borders')
          // };
          // if (map.getLayer('third-layer')) {
          //   map.removeLayer('third-layer');
          //   map.removeLayer('third-layer-borders');
          // };
          // if (map.getLayer('fourth-layer')) {
          //   map.removeLayer('fourth-layer');
          //   map.removeLayer('fourth-layer-borders');
          // };
          // if (map.getLayer('fifth-layer')) {
          //   map.removeLayer('fifth-layer');
          //   map.removeLayer('fifth-layer-borders');
          // };

          // if (map.getSource('ddnsearchSource')) {
          //   map.removeSource('ddnsearchSource')
          // }

          removePrevLayer('common-layer',"layersource");
          removePrevLayer('common-layer-border',"bordersource");
          removePrevLayer('zipprs-layers',"ddnsearchSource");
          removePrevLayer('zipprs-layer',"markers3");

          setTimeout(() => {
            map.addSource('ddnsearchSource', {
              "type": "geojson",
              "data": zippr
            })
            map.addLayer({
              "id": "zipprs-layers",
              "source": "ddnsearchSource",
              "type": "circle",
              "paint": {
                "circle-radius": 5,
                "circle-opacity": 0.8,
                "circle-stroke-width": 1,
                "circle-stroke-color": "#ff7800",
                "circle-stroke-opacity": 1,
                'circle-color': '#ff7800'
              },
            });
          }, 500)




          map.on('mousemove', 'zipprs-layers', function (e) {
            ddnSearchZipprData = e.features[0].properties;

            popup
              .setLngLat(e.lngLat)
              .setHTML("<b>" + "Zippr-Address" + "</b>" + "<br />" +
                "<span>" + e.features[0].properties.zippr + "</span>"
              )
              .addTo(map);
          });

          map.on('mouseleave', 'zipprs-layers', function () {
            map.getCanvas().style.cursor = '';
            popup.remove()
          });
          let image = "";
          let _zippr = "";
          if (ddnSearchZipprData) {
            image = ddnSearchZipprData.zippr_media.images[0].default.url;
            _zippr = ddnSearchZipprData.zippr


          }
          this.setState({
            display_zippr_data: true,
            showSidePane: false
          })
        }
      }
      }).catch(err => {
        console.log(err, "eeerrrooorrr");
        toast.error("Error!", {
          position: toast.POSITION.BOTTOM_LEFT
        });
      })
  }

  checkIsDownloadLinkShow(data, lastParams,ulbparams) {
    console.log(data[0], "data[0]");
    console.log(spaceKey[workOrder.ulbLevel], "spaceKey[workOrder.ulbLevel]ki");
    let obj = {};
    if(ulbparams){
      console.log(ulbparams,"ulbparamsulbparams")
      obj.parentKey = ulbparams[0].parentSpaceKey;
      obj.parentValue = ulbparams[0].parentId;
      // obj.spaceKey = ulbparams[0].parentSpaceKey;
      // obj.spaceValue = ulbparams[0].parentId;
      // obj.params = this.state.selectedProject.zipprs_layer.params;
    }
    if (data.length) {
      // let obj = {};
      // obj.parentKey = data[0].parentSpaceKey;
      // obj.parentValue = data[0].parentId;
      obj.spaceKey = data[0].parentSpaceKey;
      obj.spaceValue = data[0].parentId;
      obj.params = this.state.selectedProject.zipprs_layer.params;
      // console.log(obj, "obj in yyu");
      if (data[0].parentSpaceKey === spaceKey[workOrder.ulbLevel] || data[0].parentSpaceKey === spaceKey[spaceKey.length - 1]) {
        console.log(spaceKey[spaceKey.length - 1], "xfghiop");
        this.setState({
          showDownloadLink: true,
          downloadBtnData: obj
        })
      } else {
        console.log(spaceKey[spaceKey.length - 1], "xfgoooohiop");
        this.setState({
          showDownloadLink: false
        })
      }
    }

    if (lastParams) {
      console.log(lastParams, "lastParams");
      let obj = {};
      obj.spaceKey = lastParams.spaceKey;
      obj.spaceValue = lastParams.spaceValue;
      obj.parentKey = lastParams.parentKey;
      obj.parentValue = lastParams.parentValue;
      obj.params = lastParams;
      console.log(obj, "oobbjj")
      this.setState({
        showDownloadLink: true,
        downloadBtnData: obj
      })

    }
  }

  checkIsDownloadLinkShowNew(data) {
    let analyticsData=[...data];
    let ulbLevel=spaceKey[workOrder.ulbLevel];
    let obj = {};
    console.log(analyticsData,"ulbLevel000");
    if(analyticsData.length){
      let parentKey;
      let parentValue;

      if(analyticsData[0].space.parent){
        parentKey=analyticsData[0].space.parent.key;
        parentValue=analyticsData[0].space.parent.value;
      }

      let obj={};
      obj.params = this.state.selectedProject.zipprs_layer.params;

      if(analyticsData.length>1){
        console.log("inner")
        obj.spaceKey="";
        obj.spaceValue="";
      }else{
        obj.spaceKey=analyticsData[0].space.key;
        obj.spaceValue=analyticsData[0].space.value;
      }

      obj.parentKey=parentKey?parentKey:"";
      obj.parentValue=parentValue?parentValue:"";


      if(analyticsData[0].space.key==spaceKey[spaceKey.length - 1] || analyticsData[0].space.key==ulbLevel){
        console.log(analyticsData.length,"analyticsData.length");
        this.setState({
          showDownloadLink: true,
          downloadBtnData: obj
        })

      }else{
        this.setState({
          showDownloadLink: false,
        })
      }
      console.log(parentKey,"parentKet");

    }else {
      this.setState({
        showDownloadLink: false
      })
    }



  }

  downloadDdnClick(e){
    this.setState({
      loadDownloadButton:true
    });
    document.getElementById("download-btn-map").disabled = true;
    console.log(this.state.selectedProject.downloadDataFromMap.params,"clicked downloadd");
    let params=this.state.selectedProject.downloadDataFromMap.params;
    if(this.state.downloadBtnData){
    params.spaceKey=this.state.downloadBtnData.spaceKey;
    params.spaceValue=this.state.downloadBtnData.spaceValue;
    params.parentKey=this.state.downloadBtnData.parentKey;
    params.parentValue=this.state.downloadBtnData.parentValue;

    params.fromDate=this.state.downloadBtnData.params.fromDate ? this.state.downloadBtnData.params.fromDate : null;
    params.toDate=this.state.downloadBtnData.params.toDate ? this.state.downloadBtnData.params.toDate : null;
  }
    params.userKey=this.state.selectedProject.zipprs_layer.params.userKey ? this.state.selectedProject.zipprs_layer.params.userKey : null ;
    params.userValue=this.state.selectedProject.zipprs_layer.params.userValue ? this.state.selectedProject.zipprs_layer.params.userValue : null ;

    console.log(params,"parammss");
    removeNullParams(params);

    if(params.spaceKey === 'Locality'){
      axios.get(this.state.selectedProject.downloadLocalityDdnData.url, {
        params: {
          work_order: params.work_order,
          locality: params.spaceValue
        },
        headers: this.state.selectedProject.headers
      })
        .then(res => {
          console.log(res,"ress downloaddd");
          if(res.data.response.ddns.length){
            let downloadArray=[];
            res.data.response.ddns.map(ele=>{
              let obj={};
              for(let i = 0; i < res.data.response.headers.length; i++){
                obj[res.data.response.headers[i]]=ele[res.data.response.headers[i]]
              }
              downloadArray.push(obj);
            })
  
            this.setState({
              downloadArray:downloadArray,
              headers:res.data.response.headers,
              loadDownloadButton:false
            })
            console.log(downloadArray.length,"downloadArraylen")
            document.querySelector('#csvbtn').click();
            document.getElementById("download-btn-map").disabled =false;
          }
  
        })
    } else {
      axios.get(this.state.selectedProject.downloadDataFromMap.url, {
      params: params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        console.log(res,"ress downloaddd");
        if(res.data.response.zipprObjs.length){
          let downloadArray=[];
          res.data.response.zipprObjs.map(ele=>{
            let obj={};
            obj.ddn=ele.zippr;
            obj.latitude=ele.location.coordinates[0];
            obj.longitude=ele.location.coordinates[1];
            obj.createdAt=ele.createdAt;
            downloadArray.push(obj);
          })

          let headers = [
            { label: "DDN", key: "ddn" },
            { label: "Latitude", key: "latitude" },
            { label: "Longitude", key: "longitude" },
            { label: "createdAt", key: "createdAt" }
          ];
          this.setState({
            downloadArray:downloadArray,
            headers:headers,
            loadDownloadButton:false
          })
          console.log(downloadArray.length,"downloadArraylen")
          document.querySelector('#csvbtn').click();
          document.getElementById("download-btn-map").disabled =false;
        }

      })
    }
  }

  zipprListClick(e){
    console.log(e.target.name,"clicked zippr lst");
    if(e.target.name){
    this.setState({
      ddnValue:e.target.name
    },()=>{
      this.ddnSearchButton("","zipprList");
    })

  }
  }

  render() {
    // console.log(this.state, "this.statein rebder")
    //ddn_count: 1280, display_name: "Andhra Pradesh"
    let layer1_displayDataArr = this.state.layer1_displayDataArr
    if (layer1_displayDataArr.length < 1) {
      layer1_displayDataArr = [{ ddn_count: 0, display_name: "Total DDN Buildings", dwellings: 0 }]
    }
    let map_upSideShowing_layers_new = this.state.map_upSideShowing_layers_new;
    map_upSideShowing_layers_new = _.uniqBy(map_upSideShowing_layers_new, "name");
    // let length = updata.length;
    // updata.map((ele, i) => {
    //   if (length == i + 1) {
    //     ele.disable = false
    //   } else {
    //     ele.disable = true
    //   }
    // })
    console.log(this.state.buildingType)

    return (
      <div className="container-fluid">
        <div className='row'>
          {this.state.loadMap ?
            <div className="col-md-7 left-col">
              <div id="map" style={{ width: "100%", height: "600px" }} >
                <img
                  style={{ position: "relative", width: "100%" }}
                  //  src='https://cdn.shopify.com/s/files/1/0222/7018/1472/t/7/assets/shopify_logo.gif?v=7646194843727540658'
                  src={mapLoader}
                />
              </div>
            </div>
            :
            <div className="col-md-7 left-col">
              {/* <div class="col-md-12 left-col"> */}

              <div id="map" style={{ width: "100%", height: "600px" }} >
                {this.state.showSidePane ?
                  <button className='btn btn-default btn-sm map-upside-button' id='mapUpside' onClick={this.toggleLeftPaneButton}><span class="glyphicon glyphicon-chevron-left" id='direction-icon'></span></button>
                  : <button className='btn btn-default btn-sm map-upside-button' id='mapUpside' onClick={this.toggleLeftPaneButton}><span class="glyphicon glyphicon-chevron-right" id='direction-icon'></span></button>
                }
                {this.state.showSidePane ?
                  <div className='select-bar'>
                    <div class="form-group row">
                      <label className='col-sm-3 label' for="sel1">Agency</label>
                      <div className='col-sm-9'>
                        <select class="form-control" id="sel1" onChange={this.agencyFilterChange.bind(this)}>
                          <option value="all" selected={this.state.agencyFilterId == 'all' ? "selected" : ""}>All</option>
                          {this.state.WorkOrderClients.map((element) => {
                            return <option value={element.id} selected={this.state.agencyFilterId == element.id ? "selected" : ""}>{element.name}</option>
                          })
                          }

                        </select>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label className='col-sm-3 label' for="sel1">Date</label>
                      <div className='col-sm-9'>
                        <select class="form-control" id="sel1" onChange={this.dateFilter}>
                        <option value='lifetime' selected={this.state.date_filter == 'lifetime' ? 'selected' : ""}>Life Time</option>
                          <option value='today' selected={this.state.date_filter == 'today' ? 'selected' : ""}>Today</option>
                          <option value='yesterday' selected={this.state.date_filter == 'yesterday' ? 'selected' : ""}>Yesterday</option>
                          <option value='this_week' selected={this.state.date_filter == 'this_week' ? 'selected' : ""}>This Week</option>
                          <option value='last_week' selected={this.state.date_filter == 'last_week' ? 'selected' : ""}>Last Week</option>
                          <option value='last_7' selected={this.state.date_filter == 'last_7' ? 'selected' : ""}>Last 7Days</option>
                          <option value='last_14' selected={this.state.date_filter == 'last_14' ? 'selected' : ""}>last_14</option>
                          <option value='this_month' selected={this.state.date_filter == 'this_month' ? 'selected' : ""}>This Month</option>
                          <option value='last_month' selected={this.state.date_filter == 'last_month' ? 'selected' : ""}>Last Month</option>
                          <option value='custom' selected={this.state.date_filter == 'custom' ? 'selected' : ""}>Custom</option>

                        </select>
                      </div>
                    </div>
                    {this.state.date_filter == 'custom' && <div class="form-group row">
                      <label className='col-sm-3 label' for="startdate">Start Date</label>
                      <div className='col-sm-9'>
                        <DatePicker className="date-button" selected={this.state.startDate} onChange={date => this.setState({startDate: date})} />
                      </div>
                    </div>}
                    {this.state.date_filter == 'custom' && <div class="form-group row">
                      <label className='col-sm-3 label' for="startdate">End Date</label>
                      <div className='col-sm-9'>
                        <DatePicker className="date-button" selected={this.state.endDate} onChange={date => this.setState({endDate: date})} />
                      </div>
                    </div>}
                    <div className='row search-btns'>
                      <div className='col-sm-7'></div>
                      <div className='col-sm-4'>
                        <button type="button" class="btn" id='search-btn-map' onClick={this.searchClick}>Search</button>
                      </div>
                      <div className='col-sm-1'></div>
                    </div>

                    <br /> <br />  <br />

                    <div className='row search-btns'>
                      <div className='col-sm-3'></div>
                      <div className='col-sm-6 enter-ddn-group'>
                        <input type='text/json' placeholder='Enter DDN' onChange={this.enterDdnChange.bind(this)} />
                        <button className='search-icon-btn' onClick={this.ddnSearchButton.bind(this)}>  <span class="glyphicon glyphicon-search"></span></button>

                      </div>
                      <div className='col-sm-3'>
                      </div>

                    </div>

                    <br />  <br />


                  </div>
                  : ""}


                <span className='maps-top-links'>
                  {map_upSideShowing_layers_new.map((ele) => {
                    return (
                      <span> <button onClick={this.mapUpperBar} id={ele.name} name={JSON.stringify(ele)} value={ele.name} className="display-name-button btn btn-link" disabled={ele.disable} >{ele.name}</button><span>-></span> </span>
                    )
                  }
                  )}
                </span>
              </div>


              <div id='range-scale'>
                <ol className='rng'><span class='reange' id='b1'></span>&nbsp; 1-100</ol>
                <ol className='rng'><span class='reange' id='b2'></span>&nbsp; 100-1K</ol>
                <ol className='rng'><span class='reange' id='b3'></span>&nbsp; 1k-5K</ol>
                <ol className='rng'><span class='reange' id='b4'></span>&nbsp; 5k-0.1L</ol>
                <ol className='rng'><span class='reange' id='b5'></span>&nbsp; 0.1L-1L</ol>
                <ol className='rng'><span class='reange' id='b5'></span>&nbsp; 1L-2L</ol>
                <ol className='rng'><span class='reange' id='b7'></span>&nbsp; 2L-2.5L</ol>
                <ol className='rng'><span class='reange' id='b8'></span>&nbsp; 2.5L+</ol>
              </div>

              {/* <div className="map-style">
                <button className='style-change-button' name='satellite' onClick={this.mapStyleChange} style={{ border: this.state.clickedStyle == 'satellite' ? '2px solid #0d2d8f' : "none" }}>Normal</button>
                <button className='style-change-button' name='normal' onClick={this.mapStyleChange} style={{ border: this.state.clickedStyle == 'satellite' ? '2px solid #0d2d8f' : "none" }}>Satellite</button>
              </div> */}


            </div>
          }
          {/* </div> */}
          <div className="col-md-5">
          {this.state.loadMap ?
   <div class="col-md-12 right-col">
                <img
                  style={{ position: "relative", width: "100%" }}
                  //  src='https://cdn.shopify.com/s/files/1/0222/7018/1472/t/7/assets/shopify_logo.gif?v=7646194843727540658'
                  src={mapLoader}
                />

            </div>
            :
            <div class="col-md-12 right-col">
              {this.state.display_zippr_data ?
                <ZipprData zipprsData={this.state.zipprsData} />
                :
                <div>
                  <h5><b>{this.state.titel}</b></h5>

                  {layer1_displayDataArr.map((ele) => {
                    return (
                      <>
                        {this.state.loadCount ?
                          <img className='loader' src=
                            {loader}
                          />
                          :
                          <div className="right-ddn-data">
                            <Button variant="link" onClick={this.titelClick} name={JSON.stringify(ele)} className="display-name-button">{ele.display_name}</Button>
                            <div className="display-ddn-count">-&nbsp; &nbsp; {ele.ddn_count} <span>({ele.dwellings ? ele.dwellings : 0})</span></div>
                          </div>
                        }
                      </>
                    )
                  })
                  }
                  {this.state.showDownloadLink ?
                  <>
                  <CSVLink
                  id='csvbtn'
                  data={this.state.downloadArray}
                  headers={this.state.headers}
                  filename='dashboard_zipprs.csv'
                  ></CSVLink>
  <a className='download-btn-map' id='download-btn-map' onClick={this.downloadDdnClick.bind(this)}>{this.state.loadDownloadButton ? "Downloading..." :"[Download DDNs]"}</a>
                 </>
                    :
                    ""}
          {(this.state.markedZipprs.length || this.state.buildingType) ? <div className="row data-row">
            <div className="col-md-4 label-class">
              <span className="label-text">Building Type</span>
            </div>
            <div className="col-md-8 select-bordered-div">
              <Grid item md={12} xs={12}>
                <TextField
                  fullWidth
                  // label="Select State"
                  name="state"
                  // label="Client Name"
                  onChange={e => {
                    this.setState({ buildingType: e.target.value, buildingTypeFilter: false });
                  }}
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{ native: true }}
                  value={this.state.buildingType}
                  variant="outlined"
                >
                  <option value="all">All</option>
                  <option value="1">Independant</option>
                  <option value="2">Multi-Tenant</option>
                  <option value="3">Apartment</option>
                  <option value="4">vacant</option>
                </TextField>
              </Grid>
            </div>
          </div> : null}
{this.state.markedZipprs.length ?
<div class="panel panel-primary" id="result_panel">
  <br/>
  
    <div class="panel-heading">
      <h6 class="panel-title">Building DDNs</h6>
    </div>
    <div class="panel-body">
        <ul class="list-group">
        {this.state.markedZipprs.map((zippr)=>{
          return <li class="list-group-item" id='display-zipprs'>
          <strong style={{color:'#337ab7'}}>
            <a name={zippr} onClick={this.zipprListClick.bind(this)}>
           {zippr}
           </a>
            </strong>
        </li>
        }) }


            </ul>
            </div>
            </div>
            : ""}

                </div>


              }

            </div>
            }
          </div>
        </div>

      </div>
    )
  }
}



function getNextLabel(label,hierarchy){
  let nextIndex;
   let nextLabel;
  hierarchy.map((ele,index)=>{
  if(ele==label){
  if(hierarchy.length==index+1){
  nextIndex=""
  }else{
  nextIndex=index+1;
  }
  console.log(hierarchy[nextIndex],"nextIndex");

   if(nextIndex){
   nextLabel=hierarchy[nextIndex];
  }else{
  nextLabel=""
  }
  }
  })
  return nextLabel;
  }

  function removePrevLayer(layer, source) {
    if (map.getLayer(layer)) {
        map.removeLayer(layer);
    }
    if (map.getSource(source)) {
        map.removeSource(source);
    }
}

function removePreviousNamesInUpperBar(label,hierarchy){
  if(label==hierarchy[0].label){
    console.log("first00000")
  return [];
  }else{
   hierarchy.map((ele,index)=>{
 if(ele.label==label){
 hierarchy.splice(index);
 }
 });
 console.log(hierarchy,"ressss88")
 return hierarchy;
  }
 }

 function getPreviousLabel(label,hierarchy){
  let nextIndex;
   let nextLabel;
  hierarchy.map((ele,index)=>{
  if(ele==label){
  nextIndex=index-1;
   if(nextIndex){
   nextLabel=hierarchy[nextIndex];
  }else{
  nextLabel=""
  }
  }
  })
  return nextLabel;
  }
